import React from "react";
import { Link } from "react-router-dom";
import projectData from "../Data/ProjectsData";
import { useState } from "react";
import Projects from "./Projects";
import "./Projects.css";

const ProjectGallery = () => {
  const projectSlice = projectData.slice(0, 2);
  const [projects] = useState(projectSlice);
  return (
    <div  id="projects" className="container mb-5 mt-5">
      <div className="project-gallery-header-text pt-5">
        <h1 className="text-center text-white font-weight-bold mb-5 pb-5">
          My Recent Projects
        </h1>
      </div>
      <div className="row d-flex justify-content-around">
        {projects.map((project) => (
          <Projects project={project} key={project.id} />
        ))}
      </div>
      <div className="more text-center">
        <Link
          to="/moreProjects"
          className="btn btn-outline-primary font-weight-bold text-white"
        >
          More Projects
        </Link>
      </div>
    </div>
  );
};

export default ProjectGallery;
